import { render, staticRenderFns } from "./DebugBar.vue?vue&type=template&id=2a5855ad"
import script from "./DebugBar.vue?vue&type=script&lang=js"
export * from "./DebugBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports